import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';

const spacingAction = createDefaultActionDefinition(
  StylesDerivedNativeActions.spacingStyles,
);

export default spacingAction;
